import { FunctionComponent } from 'react';
import { useGetKeycardsQuery } from '@/api/v2/keycards';
import { Stack } from '@mui/material';
import { Customer } from '@/models/customer';
import { OrderDetailsKeycardsTable } from '@/pageContents/customers/orderDetails/OrderDetailsKeycardsTable';

type CustomerKeycardsListProps = {
    customer: Customer;
};

export const CustomerKeycardsList: FunctionComponent<
    CustomerKeycardsListProps
> = ({ customer }) => {
    const { data: keycards } = useGetKeycardsQuery({
        customerId: customer.id,
    });

    if (!keycards) return null;

    return (
        <Stack spacing={3}>
            <OrderDetailsKeycardsTable keycards={keycards} />
        </Stack>
    );
};
